(function () {
  'use strict';

  // YMAL rule IDs on Umed Mart: Fresh = 503, Standard = 499.
  var TEMPLATE_RULE_IDS = {
    'umedmart-fresh': [503],
    '': [499]
  };
  var installed = false;

  function log(label, data) {
    if (window.SalepifyYmalTemplateSelectorConfig?.debug === false) return;
    window.console?.log?.('[Salepify YMAL template] ' + label, data);
  }

  function currentTemplateSuffix() {
    var scope = window.SalepifyPgbProductScope;
    if (!scope || !Object.prototype.hasOwnProperty.call(scope, 'templateSuffix')) return null;
    return typeof scope.templateSuffix === 'string' ? scope.templateSuffix : '';
  }

  function currentProductId() {
    var handle = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    var candidates = [window.ShopifyAnalytics?.meta?.product, window.meta?.product];
    for (var i = 0; i < candidates.length; i++) {
      var product = candidates[i];
      if (!product?.id) continue;
      if (!handle || !product.handle || product.handle === decodeURIComponent(handle)) return String(product.id);
    }
    return null;
  }

  function install(instance) {
    if (!instance || installed || typeof instance.checkCartData !== 'function' || typeof instance.checkRuleCondition !== 'function') return;
    installed = true;

    var originalCheckCartData = instance.checkCartData.bind(instance);
    var originalCheckRuleCondition = instance.checkRuleCondition.bind(instance);

    instance.checkCartData = async function () {
      var cartData = await originalCheckCartData();
      if (instance.template !== 'product') return cartData;
      var productId = currentProductId();
      return productId ? Object.assign({}, cartData, { productInCart: [productId] }) : cartData;
    };

    instance.checkRuleCondition = async function (rule, productInCart) {
      if (instance.template !== 'product') return originalCheckRuleCondition(rule, productInCart);

      var suffix = currentTemplateSuffix();
      var allowedRuleIds = TEMPLATE_RULE_IDS[suffix] || [];
      if (allowedRuleIds.indexOf(Number(rule.id)) === -1) return false;

      // YMAL's core checker uses trigger_type to decide whether this product is eligible.
      // Force `all` only after the template has selected the dedicated rule.
      return originalCheckRuleCondition(Object.assign({}, rule, { trigger_type: 'all' }), productInCart);
    };

    log('installed', {
      templateSuffix: currentTemplateSuffix(),
      allowedRuleIds: TEMPLATE_RULE_IDS[currentTemplateSuffix()] || []
    });
    setTimeout(function () {
      if (instance.template === 'product') instance.checkApplyOffer?.();
    }, 0);
  }

  var existing = window.tlYMAL;
  if (existing) install(existing);

  try {
    var instance;
    Object.defineProperty(window, 'tlYMAL', {
      configurable: true,
      enumerable: true,
      get: function () { return instance; },
      set: function (value) {
        instance = value;
        install(value);
      }
    });
    if (existing) window.tlYMAL = existing;
  } catch (error) {
    // A late-loaded custom script can encounter a non-configurable global.
    // The existing instance has already been patched above when available.
    log('could not intercept future instance', error);
  }
}());
